import { render, staticRenderFns } from "./ModificarProductoVenta.vue?vue&type=template&id=240c7aa6&scoped=true&"
import script from "./ModificarProductoVenta.vue?vue&type=script&lang=js&"
export * from "./ModificarProductoVenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c7aa6",
  null
  
)

export default component.exports